export const LOADING_INDICATOR_STYLES = {
    'background-color': 'rgba(0, 0, 0, 0.4)',
    'z-index': '1000',
};
